/**
 * 根据订单状态返回状态文字颜色类名
 * @param {string} state 订单状态码
 * @returns {string} Element UI 风格文字颜色类名
 */
export function getStateClass(state) {
  const stateColorMap = {
    '1': 'text-warning',   // 待支付：需关注
    '0': 'text-primary',   // 待发货：流转中
    '00': 'text-primary',  // 待备货：流转中
    '02': 'text-primary',  // 到店核销：流转中
    '2': 'text-primary',   // 待收货：流转中
    '3': 'text-success',   // 已收货：完成
    '4': 'text-info',      // 待评价：等待用户动作
    '5': 'text-danger',    // 已退款：异常/资金回退
    '6': 'text-danger',    // 申请退款：异常/资金回退
    '7': 'text-info',      // 退货成功：流程结束
    '8': 'text-success',   // 已完成：完成
    '9': 'text-info',      // 未支付关闭：流程结束
    '10': 'text-info',     // 已取消：流程结束
    // 新外送/自提状态机（REQ20260904006）：11-17 与小程序商家端状态文案一致（t_dict store_order/state）
    '11': 'text-warning',  // 已支付待接单：需商家动作
    '12': 'text-warning',  // 已支付待核销：需商家动作
    '13': 'text-primary',  // 备货中：流转中
    '14': 'text-primary',  // 待配送：流转中
    '15': 'text-primary',  // 待取货：流转中
    '16': 'text-primary',  // 配送中：流转中
    '17': 'text-danger'    // 配送异常：异常
  }
  return stateColorMap[state] || ''
}

/**
 * 是否新外送/自提状态机状态（11-17）
 * PC 后台对新状态单仅只读查看，接单/备货/配送操作载体为商家小程序
 * @param {string} state 订单状态码
 * @returns {boolean}
 */
export function isNewStateMachine(state) {
  return ['11', '12', '13', '14', '15', '16', '17'].includes(String(state))
}
